import { Button, Checkbox, Modal, Text } from "../../../../components";
import Localization from "../../../../localization";
import React, { useRef, useState } from "react";
import { Images } from "../../../../assets";
import useViewModel from "../../viewModel";
import { Enums } from "../../../../utils";
import { Flex } from "antd";
import Steps from "./steps";

const Content = ({
  close = () => {},
  showTerms = () => {},
  showSteps = () => {},
}) => {
  const { updateProgress, isConfigured, getCard } = useViewModel();
  const [agreed, setAgreed] = useState(false);
  return (
    <>
      <Text
        weight={700}
        type="secondary"
        children={Localization.service.alarmSMS_inactive_info_title}
      />
      <Text
        weight={400}
        type="secondary"
        className="m-10-t"
        children={Localization.service.alarmSMS_inactive_info_desc}
      />
      <Text
        weight={700}
        className="m-10-t"
        children={Localization.formatString(
          Localization.service.alarmSMS_inactive_info_subtitle_0,
          30
        )}
      />
      <Checkbox
        checked={agreed}
        className="m-30-t"
        onChange={(_) => setAgreed(_.target.checked)}
        children={
          <Text
            type="secondary"
            children={Localization.formatString(
              Localization.service.alarmSMS_intro_terms_desc,
              <Text
                level={"text"}
                decoration={"underline"}
                children={Localization.service.alarmSMS_intro_terms_text}
                onClick={(e) => {
                  e.stopPropagation();
                  showTerms();
                }}
              />
            )}
          />
        }
      />
      <Flex wrap="wrap" className="m-30-t" gap={"1rem"}>
        <Button
          type="primary"
          disabled={!agreed}
          title={Localization.general.activate}
          onClick={() => {
            showSteps();
            close();
          }}
        />
        <Button
          title={Localization.general.later}
          onClick={async () => {
            if (!isConfigured)
              await updateProgress({
                [Enums.serviceCardIDs.alarmSms]: false,
              });
            close();
          }}
        />
        <Button
          title={Localization.general.read_more}
          onClick={() =>
            window.open(getCard(Enums.serviceCardIDs.alarmSms)?.readMoreUrl)
          }
        />
      </Flex>
    </>
  );
};

const Introduction = ({}, ref) => {
  const termsModalRef = useRef();
  const stepsRef = useRef();

  return (
    <>
      <Modal
        ref={ref}
        body={{
          fixedHeader: false,
          background: `url(${Images.alarmSmsIntroCardBg})`,
        }}
        children={
          <Content
            close={() => ref.current.close()}
            showSteps={() => stepsRef.current.start()}
            showTerms={() => termsModalRef.current.open()}
          />
        }
        title={{
          children: (
            <>
              <Text
                level={4}
                weight={700}
                lineHeight="normal"
                children={Localization.service.alarmSMS_intro_title}
              />
            </>
          ),
        }}
      />
      <Modal
        ref={termsModalRef}
        title={Localization.service.alarmSMS_term_title}
      >
        <Flex
          vertical
          gap={"2rem"}
          children={React.Children.toArray(
            [
              {
                title: Localization.service.alarmSMS_term_cond_0_title,
                desc: Localization.service.alarmSMS_term_cond_0_subtitle,
              },
              {
                title: Localization.service.alarmSMS_term_cond_1_title,
                desc: Localization.service.alarmSMS_term_cond_1_subtitle,
              },
              {
                title: Localization.service.alarmSMS_term_cond_2_title,
                desc: Localization.service.alarmSMS_term_cond_2_subtitle,
              },
              {
                title: Localization.service.alarmSMS_term_cond_3_title,
                desc: Localization.service.alarmSMS_term_cond_3_subtitle,
              },
              {
                title: Localization.service.alarmSMS_term_cond_4_title,
                desc: Localization.service.alarmSMS_term_cond_4_subtitle,
              },
            ].map((_, index) => (
              <div>
                <Text
                  level={5}
                  weight={700}
                  type="secondary"
                  children={`${index + 1}. ${_.title}`}
                />
                <Text type="secondary" children={_.desc} className="m-10-t" />
              </div>
            ))
          )}
        />
        <Button
          type="primary"
          className="m-30-t"
          title={Localization.general.okay}
          onClick={() => termsModalRef.current.close()}
        />
      </Modal>
      <Steps ref={stepsRef} />
    </>
  );
};

export default React.forwardRef(Introduction);
